<!--
 * @Description: 组织管理新
 * @Autor: xiaona.wang
 * @Date: 2021-12-01 20:57:00
 * @LastEditors: xiaona.wang
 * @LastEditTime: 2022-01-10 19:44:11
-->

<template>
  <div class="app-wrap">
    <TreeListLayoutAdapter>
      <template #tree>
        <div style="padding: 8px 4px 0 4px">
          <el-input
            v-model.trim="treeSearchValue"
            :placeholder="$t('common.search')"
            class="self-filter-input"
            size="small"
            clearable
            @keyup.enter.native="handleSearchTree"
          >
            <i
              slot="suffix"
              class="el-input__icon el-icon-search cursor-p"
              @click="handleSearchTree"
            />
          </el-input>
        </div>
        <!-- tree树 -->
        <el-tree
          ref="tree"
          class="self-tree"
          :props="defaultProps"
          :data="treeData"
          node-key="id"
          :highlight-current="true"
          :default-expanded-keys="defaultShowNodes"
          :expand-on-click-node="false"
          :filter-node-method="filterNode"
          @node-click="handleNodeClick"
          @node-expand="handleNodeExpand"
          @node-collapse="handleNodeCollapse"
        >
          <span slot-scope="{ node }" :title="node.label" class="self-custom-tree">
            <span style="padding-right: 10px">{{ node.label }}</span>
          </span>
        </el-tree>
      </template>

      <template #datatable>
        <!-- todo 处理更多选项 -->
        <div class="pt8 h100">
          <general-table
            ref="tableInstance"
            :code="tableCode"
            :table-sort-custom="tableSortCustom"
            :version="tableVersion"
            title="部门管理"
            :search-placeholder="$t('org.searchPlaceHolder')"
            :columns="tableColumns"
            :data="tableData"
            :pagination="pagination"
            :loading="tableLoading"
            @refresh="handleRefresh"
            @handleSizeChange="handlePaginationChange"
            @handleCurrentChange="handlePaginationChange"
            @search="handleSearch"
            @batchDeleteData="deleteData"
            @changeCustomSort="changeCustomSort"
          >
            <template #effect="{ item }">
              <el-switch
                v-model="item.effect"
                active-icon-class="el-icon-check"
                @change="changeSwitch(item.effect, item)"
              ></el-switch>
            </template>
            <template #operations>
              <!-- todo 处理这里的一系列操作 -->
              <el-popover
                ref="popover"
                placement="bottom"
                trigger="hover"
                :visible-arrow="false"
                class="cursor-p self-popover pr8"
              >
                <div slot="reference">
                  <el-button>
                    <!-- {{ $t("common.import") + "/" + $t("common.export") }} -->
                    {{ $t('common.export') }}
                    <i class="el-icon-arrow-down" />
                  </el-button>
                </div>
                <div class="self-popover-items" style="min-width: 114px">
                  <!-- <p class="self-popover-item">
                    {{ $t("common.import") }}
                  </p> -->
                  <p class="self-popover-item" @click="exportExcel">
                    {{ $t('common.export') }}
                  </p>
                </div>
              </el-popover>
              <el-button
                icon="el-icon-circle-plus-outline"
                type="primary"
                :loading="addLoading"
                @click="handleShow()"
              >
                {{ $t('org.createOrg') }}
              </el-button>
              <el-button type="primary" @click="handleSyncDepartment">同步部门</el-button>
            </template>

            <template #operation="{ scope }">
              <el-button
                type="text"
                class="btn__text--no-padding"
                @click="handleShow(scope.row, 'details')"
              >
                {{ $t('common.view') }}
              </el-button>
            </template>

            <template #operationMore="{ scope }">
              <p class="self-popover-item text_detail" @click="handleShow(scope.row, 'edit')">
                {{ $t('common.edit') }}
              </p>
              <p
                class="self-popover-item error text_detail"
                @click="handleDeleteShow(scope.row, 'edit')"
              >
                {{ $t('common.delete') }}
              </p>
            </template>
          </general-table>
        </div>
      </template>
    </TreeListLayoutAdapter>

    <!-- 表格删除确认框 start-->
    <delete-dialog
      layout="left"
      :visible.sync="deleteDialogVisible"
      :content="deleteContent"
      :loading.sync="deleteLoading"
      @confirm="handleDeleteConfirm"
    />
    <!-- /表格删除确认框 end-->
    <!-- 新增|编辑|查看|补录弹框 start-->
    <org-new-info
      v-if="dialogInfoVisible"
      :visible.sync="dialogInfoVisible"
      :prop-data="dialogData"
      @success="handleUpdateList"
    />
    <!-- 新增|编辑弹框 end-->
    <!-- 表格删除确认框 start-->
    <reset-password-dialog
      layout="left"
      :visible.sync="resetDialogVisible"
      :content="resetContent"
      :loading.sync="resetLoading"
      @confirm="handleUpdateList"
    />
    <!-- /表格删除确认框 end-->
    <!-- 导入|导出弹框 start-->
    <upload-dialog
      ref="uploadDialog"
      :visible.sync="uploadDialogVisible"
      :error-data="errorData"
      @fileDownload="templeteExcelExport"
      @errorDownLoad="errorDownLoad"
    />
    <!-- 导入|导出弹框 end-->
  </div>
</template>

<script>
import orgApi from "@/api/org/org";
import { mapGetters } from "vuex";
import { commonFilterNode } from "@/utils";
import DeleteDialog from "@/components/common/Dialogs/DeleteDialog";
import OrgNewInfo from "./components/org-new-info";
import ResetPasswordDialog from "@/components/common/Dialogs/ResetDialog";
import UploadDialog from "@/components/common/Dialogs/newUploadDialog";
import ExcelApi from "@/api/excel";
import tableApi from "@/api/general-table";

export default {
  name: "OrgNewList",
  components: {
    DeleteDialog,
    OrgNewInfo,
    ResetPasswordDialog,
    UploadDialog
  },
  filters: {
    // 角色和组织数据列转换为对应的name
    dataTrans: value => {
      let role = "";
      if (value && value.length) {
        for (let i = 0; i < value.length; i++) {
          if (i === 0) {
            role = value[i].name;
          } else {
            role += `;${value[i].name}`;
          }
        }
      }
      return role;
    }
  },

  data() {
    return {
      // excel start
      errorData: {
        isShow: false,
        ButtonState: false
      },
      errorAttachmentId: "",
      attachName: "",
      uploadDialogVisible: false,
      // excel end
      treeSearchValue: "",
      tableLoading: false,
      dialogVisible: false,
      dialogInfoVisible: false,
      deleteDialogVisible: false,
      resetPasswordVisible: false,
      deleteLoading: false,
      resetDialogVisible: false,
      resetLoading: false,
      dialogData: {},
      loading: false,
      currentNode: {},
      addLoading: false,
      defaultProps: {
        label: "orgName",
        children: "children"
      },
      treeData: [],
      searchForm: {
        value: ""
      },
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      defaultShowNodes: [],
      formData: {
        roles: []
      },
      roleList: [],
      roleId: [],
      deleteContent: {
        title: "确定要删除该部门吗",
        description: "删除后该部门将无法使用系统"
      },
      resetContent: {
        title: "确定要重置密码吗?",
        description: "重置后用户只能使用系统默认密码登录。"
      },
      tableColumns: [
        {
          label: this.$t("org.orgName"),
          key: "orgName",
          width: "230",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("org.orgCode"),
          key: "orgCode",
          width: "200",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("org.orgShortName"),
          key: "orgShortName",
          width: "180",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("org.isEffect"),
          key: "effect",
          width: "180",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("org.address"),
          key: "address",
          width: "220",
          fixed: false,
          hidden: false
        },
        {
          label: this.$t("org.sort"),
          key: "sort",
          // width: "100",
          fixed: false,
          hidden: false
        }
      ],
      tableCode: "TABLE_CODE_COMMON_ORG_MANAGE",
      tableVersion: 1,
      tableSortCustom: [],
      tableSortDisabled: [],
      tableSearchVal: ""
    };
  },

  computed: {
    ...mapGetters(["tenantId"])
  },

  created() {
    // 获取组织树
    this.initTableData();
  },
  methods: {
    async initTableData() {
      this.tableSortCustom = [];
      if (this.tableCode) {
        const { data = {} } = await tableApi.getFormByCode(this.tableCode);
        const { orders } = data;
        orders && (this.tableSortCustom = orders);
      }
      // 获取列表数据
      this.getOrgTree(true);
    },
    changeCustomSort(sort) {
      this.tableSortCustom = sort;
      this.getList();
    },
    handleSyncDepartment() {
      orgApi
        .syncDepartment({ tenantId: this.tenantId })
        .then(
          res => {
            const { success } = res;
            if (success) {
              this.$message.success("同步成功！");
            }
          },
          () => {
            this.$message.error("同步失败！");
          }
        )
        .catch(() => {
          this.$message.error("同步失败！");
        });
    },
    /**
     * @description: 搜索
     * @param {*}
     * @return {*}
     */
    handleSearch(searchValue) {
      this.pagination.total = 0;
      this.pagination.pageNum = 1;
      this.tableData = [];
      this.tableSearchVal = searchValue;
      this.getList();
    },
    changeSwitch(effect, row) {
      orgApi
        .setEffect(row)
        .then(res => {
          if (res.success) {
            if (effect) {
              this.$message.success("已成功设置为有效!");
            } else {
              this.$message.success("已成功设置为无效!");
            }
          }
        })
        .catch(() => {
          this.getList();
        });
    },
    // 重置密码
    resetPassword(row) {
      this.resetRow = [row.id];
      this.resetDialogVisible = true;
    },
    // 创建修改编辑,
    handleShow(data = {}, type = "add") {
      this.dialogData.pageType = type;
      this.dialogData.orgTree = this.treeData;
      if (type !== "add") {
        // debugger;
        this.dialogData.id = data.id;
        // //转换组织数据并添加到对象中
        // const org = data.organizations;
        // const orgIds = [];
        // const orgName = [];
        // if (org && org.length > 0) {
        //   for (let i = 0; i < org.length; i++) {
        //     orgIds.push(org[i].id);
        //     orgName.push(org[i].orgName);
        //     //orgName.push("树根互联广州分部");
        //   }
        //   this.dialogData.parentId = orgIds;
        //   this.dialogData.parentName = orgName;
        // }
      } else {
        const currentNode = this.$refs.tree.getCurrentNode();
        this.dialogData.parentId = [currentNode.id];
        this.dialogData.parentName = [currentNode.orgName];
      }
      this.dialogInfoVisible = true;
    },
    // 获取Tree列表
    getOrgTree(isFirst = false) {
      const params = {
        parseToTree: true
      };
      orgApi.getOrgList(this.tenantId, params).then(res => {
        const { data } = res || {};
        if (data && data.length !== 0) {
          this.treeData = [data];
          if (isFirst) {
            const [node] = this.treeData;
            this.currentNode = node;
            this.$nextTick(() => {
              this.defaultShowNodes.push(node.id);
              this.$refs.tree && this.$refs.tree.setCheckedKeys([node.id]);
            });
          }
          this.$nextTick(() => {
            this.$refs.tree && this.$refs.tree.setCurrentKey(this.currentNode.id);
          });
          this.getList();
        }
      });
    },
    // 获取用户列表数据
    getList(search) {
      this.tableLoading = true;
      const params = {
        page: this.pagination.pageNum,
        size: this.pagination.pageSize,
        parentId: this.currentNode.id,
        search: this.tableSearchVal
      };
      if (Array.isArray(this.tableSortCustom)) {
        for (let i = 0; i < this.tableSortCustom.length; i++) {
          const item = this.tableSortCustom[i];
          params[`orders[${i}].asc`] = item.asc;
          params[`orders[${i}].column`] = item.column;
        }
      }
      orgApi.getList(params).then(res => {
        this.tableLoading = false;
        const { data } = res;
        if (data) {
          const { records = [], total = 0 } = data;
          this.tableData = records;
          this.pagination.total = Number(total);
        }
      });
    },
    // 分配角色按钮触发事件
    handleAssignRoles(row) {
      this.dialogVisible = true;
      this.userId = row.id;
      const roleId = [];
      if (row.roles) {
        row.roles.forEach(item => {
          roleId.push(item.id);
        });
      }
      this.formData.roles = roleId;
    },
    roleChange(item) {
      this.$forceUpdate();
    },
    // 关联角色
    handleConfirm() {
      this.loading = true;
      const params = {
        keys: this.formData.roles,
        operation: "REPLACE"
      };
      orgApi
        .userAssignRole(this.userId, params)
        .then(res => {
          this.dialogVisible = false;
          this.loading = false;
          this.$message.closeAll();
          this.$message.success(this.$t("user.assginSuccess"));
          this.getList();
          this.formData = {};
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 关闭弹框
    dialogClosed() {
      this.dialogVisible = false;
      this.formData = {};
    },
    // 点击组织树节点，查询列表
    handleNodeClick(node) {
      this.currentNode = node;
      this.pagination.pageNum = 1;
      this.pagination.total = 0;
      this.tableData = [];
      this.getList();
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(this.currentNode.id);
      });
    },
    // 新增、编辑、删除、重置密码等弹框保存成功后回调：刷新列表
    handleUpdateList() {
      this.getOrgTree();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, "pagination", data);
      this.getList();
    },
    // 查找组织树
    handleSearchTree() {
      this.$refs.tree.filter(this.treeSearchValue);
    },
    // 树节点展开
    handleNodeExpand(data) {
      // 保存当前展开的节点
      let flag = false;
      this.defaultShowNodes.some(item => {
        if (item === data.id) {
          // 判断当前节点是否存在， 存在不做处理
          flag = true;
          return true;
        }
      });
      if (!flag) {
        // 不存在则存到数组里
        this.defaultShowNodes.push(data.id);
      }
    },
    // 树节点关闭
    handleNodeCollapse(data) {
      this.defaultShowNodes.some((item, i) => {
        if (item === data.id) {
          // 删除关闭节点
          this.defaultShowNodes.length = i;
        }
      });
    },
    // 筛选组织树
    filterNode(value, data, node) {
      return commonFilterNode(value, data, node);
    },
    // table刷新
    handleRefresh() {
      this.$emit("refresh");
    },
    // 单行删除操作
    handleDeleteShow(row) {
      this.deleteRows = [row.id];
      this.deleteContent.title = `确定要删除部门"${row.orgName}"吗？`;
      this.deleteDialogVisible = true;
    },
    // 删除提交
    handleDeleteConfirm() {
      this.deleteLoading = true;
      orgApi
        .deleteItems(this.deleteRows)
        .then(res => {
          this.deleteLoading = false;
          this.deleteDialogVisible = false;
          this.$message.success(this.$t("common.deleteSuccess"));
          this.handleUpdateList();
        })
        .catch(() => {
          this.deleteLoading = false;
          this.deleteDialogVisible = false;
        });
    },
    // 批量删除
    deleteData(data) {
      this.deleteRows = data.map(res => res.id);
      this.deleteDialogVisible = true;
    },
    // 文件导入
    fileUpload(file) {
      this.errorData.ButtonState = true;
      const data = new FormData();
      data.append("file", file.raw);
      ExcelApi.importExcelOfother(data, "product-info").then(res => {
        this.errorData.ButtonState = false;
        if (res.success && res.code === 200) {
          this.errorData.attachmentId = res.data.attachmentId;
          this.errorData.isShow = true;
          if (!res.data.success) {
            this.errorData.messageContent = `插入${res.data.successCount}/${
              res.data.totalCount === null ? 0 : res.data.totalCount
            }条数据。${res.data.message}`;
            this.errorData.color = "error";
            this.errorAttachmentId = res.data.attachmentId;
          } else {
            this.errorData.messageContent = `插入${res.data.successCount}/${res.data.totalCount}条数据。`;
            this.errorData.color = "success";
          }
        } else {
          this.$message({
            message: "文件导入失败",
            type: "warning"
          });
        }
      });
    },
    // 下载错误日志
    errorDownLoad() {
      this.downloadTemplate(this.errorAttachmentId);
    },
    templeteExcelExport() {
      this.getAttachmentId("product-info");
    },
    // 文件导出
    exportExcel() {
      const params = {
        search: this.tableSearchVal,
        parentId: this.currentNode.id
      };
      if (Array.isArray(this.tableSortCustom)) {
        for (let i = 0; i < this.tableSortCustom.length; i++) {
          const item = this.tableSortCustom[i];
          params[`orders[${i}].asc`] = item.asc;
          params[`orders[${i}].column`] = item.column;
        }
      }
      orgApi.exportOrg(params).then(result => {
        this.streamingFileConversion(result);
      });
    },
    // 流文件的转换
    streamingFileConversion(result) {
      const blob = new Blob([result.data], {
        type: "application/vnd.ms-excel"
      }); // 构造一个blob对象来处理数据
      const fileName = result.filename; // 导出文件名
      /*
       * 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
       * IE10以上支持blob但是依然不支持download
       */
      if ("download" in document.createElement("a")) {
        // 支持a标签download的浏览器
        const link = document.createElement("a"); // 创建a标签
        link.download = fileName; // a标签添加属性
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click(); // 执行下载
        URL.revokeObjectURL(link.href); // 释放url
        document.body.removeChild(link); // 释放标签
      } else {
        // 其他浏览器
        navigator.msSaveBlob(blob, fileName);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.app-wrap {
  width: 100%;
  height: 100%;
}

.self-drag-right {
  background-color: #fff;
  padding: 20px;
  .r-b-title {
    margin-bottom: 16px;
  }
}
::v-deep.self-filter-input .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
}
</style>
